/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TrainingPlanSetLinkedItemBodyItemsInner { 
    /**
     * 
     */
    type: string;
    /**
     * 
     */
    module: TrainingPlanSetLinkedItemBodyItemsInner.ModuleEnum;
    /**
     * 
     */
    id: string;
}
export namespace TrainingPlanSetLinkedItemBodyItemsInner {
    export type ModuleEnum = 'portfolio';
    export const ModuleEnum = {
        Portfolio: 'portfolio' as ModuleEnum
    };
}


